angular.module('NumbersEditor')
    .controller('SportCodeEditController', [
        '$scope', '$routeParams', 'SportCodeFactory', 'authFactory', '$location', '$rootScope', '$dialogs', '$document', 'sportCodeService',
        function ($scope, $routeParams, sportCodeFactory, authFactory, $location, $rootScope, $dialogs, $document, sportCodeService) {

            init();

            $scope.isSubmitting = false;
            var _isValid = true;
            var _errorMessage = "";

            function init() {
                if (authFactory.GetAuthenticationData().isAdmin) {
                    $scope.ForNew = $routeParams.sportCode === undefined;
                    var title = ($scope.ForNew ? "Add" : "Edit") + " Sport Code";
                    $rootScope.SetAppTitle(title, title);
                    getSportCode();
                } else {
                    $location.path("");
                }
            };

            function getSportCode() {
                sportCodeService.getSportCode($scope.ForNew ? '0' : $routeParams.sportCode)
                    .then(function (sportCodes) {
                        $scope.SportCode = sportCodes;
                        $scope.SportCode.IsValid = true;
                        $scope.SportCode.MinimaIsValid = true;
                        $scope.SportCode.MaximaIsValid = true;
                        $scope.SportCode.ResultPlacesIsValid = true;

                        for (x in $scope.SportCode.SportCodeList) {
                            var item = $scope.SportCode.SportCodeList[x];
                            if (item.SportCode === $scope.SportCode.SportCode) {
                                $scope.SportCode.SportCodeDesc = item.Description;
                            }
                        }
                    })
                    .catch(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            };

            $scope.validateMinima = function () {
                validate($scope.SportCode.Minima, 'Minima', validateMinimaMaxima);
                $scope.SportCode.MinimaIsValid = _isValid;
                $scope.SportCode.MinimaErrorMessage = _errorMessage;
                setIsValid();
            }

            $scope.validateMaxima = function () {
                validate($scope.SportCode.Maxima, 'Maxima', validateMinimaMaxima);
                $scope.SportCode.MaximaIsValid = _isValid;
                $scope.SportCode.MaximaErrorMessage = _errorMessage;
                setIsValid();
            }

            $scope.validateResultPlaces = function () {
                validate($scope.SportCode.ResultPlaces, 'Number of balls drawn', validateResultPlaces);
                $scope.SportCode.ResultPlacesIsValid = _isValid;
                $scope.SportCode.ResultPlacesErrorMessage = _errorMessage;
                setIsValid();
            }

            function validate(value, desc, validateField) {
                _errorMessage = "";
                _isValid = true;

                if (isNaN(value) === true) {
                    _errorMessage = desc + " is not a number";
                    _isValid = false;
                }

                if (value % 1 != 0) {
                    _errorMessage = desc + " cannot be a decimal number";
                    _isValid = false;
                }

                var valueNumber = parseInt(value, desc);
                validateField(valueNumber, desc);
            }

            function validateMinimaMaxima(valueNumber, desc) {
                if (valueNumber < 1 || valueNumber >= 1000) {
                    _errorMessage = desc + " must be in the range 1 to 999";
                    _isValid = false;
                }
            }

            function validateResultPlaces(valueNumber, desc) {
                if (valueNumber < 1 || valueNumber > 100) {
                    _errorMessage = desc + " must be in the range 1 to 100";
                    _isValid = false;
                }

                // Check that it's not more than the Maxima minus the Minima
                if (valueNumber > ($scope.SportCode.Maxima - $scope.SportCode.Minima + 1)) {
                    _errorMessage = desc + " is greater than the ball range (maxima minus minima)";
                    _isValid = false;
                }
            }

            function setIsValid() {
                $scope.SportCode.IsValid = $scope.SportCode.MinimaIsValid && $scope.SportCode.MaximaIsValid && $scope.SportCode.ResultPlacesIsValid;
            }

            $scope.SaveSportCode = function () {
                if (saveValidate()) {
                    $scope.isSubmitting = true;
                    sportCodeFactory.saveSportCode($scope.SportCode)
                        .success(function () {
                            $.message(MessageText.SportCodeSuccessfullySaved, MessageType.Success);
                            $location.path('setupsportcodes');
                        })
                        .error(function (error) {
                            $.message(error.Message, MessageType.Error);
                            $scope.isSubmitting = false;
                        });
                }
            }

            function saveValidate() {
                var sportCode = $scope.SportCode;
                var validationPassed = true;
                if (sportCode.Minima < 1 || sportCode.Minima >= 1000) {
                    $.message('The Minima must be in the range 1 to 999', MessageType.Error);
                    validationPassed = false;
                };
                if (sportCode.Maxima < 1 || sportCode.Maxima >= 1000) {
                    $.message('The Maxima must be in the range 1 to 999', MessageType.Error);
                    validationPassed = false;
                };
                if (sportCode.ResultPlaces < 1 || sportCode.ResultPlaces >= 1000) {
                    $.message('The Number of balls drawn must be in the range 1 to 100', MessageType.Error);
                    validationPassed = false;
                };
                if (sportCode.Minima >= sportCode.Maxima) {
                    $.message('The Maxima must be greater than the Minima', MessageType.Error);
                    validationPassed = false;
                };
                if (sportCode.ResultPlaces > (sportCode.Maxima - sportCode.Minima + 1)) {
                    $.message('The number of balls is greater than the ball range (maxima minus minima)', MessageType.Error);
                    validationPassed = false;
                };
                return validationPassed;
            }

            $scope.CancelSaveSportCode = function () {
                $location.path("setupsportcodes");
            }
        }
    ]);